import { render } from "./SmReportFileIcon.vue?vue&type=template&id=141e8a2d&scoped=true"
const script = {}

import "./SmReportFileIcon.vue?vue&type=style&index=0&id=141e8a2d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141e8a2d"]])

export default __exports__